module.exports = __webpack_public_path__ + "img/equipos-moviles-img-1.16111db6.jpg";